import React, { useState, useEffect, useContext } from "react"
import { useParams } from 'react-router-dom'
import UserContext from '../context/UserContext'

import Navbar from "../components/Navbar"
import NavbarWhitelisted from "../components/NavbarWhitelisted"

import { API, graphqlOperation } from "aws-amplify"
import { queryFccArticlesByListFccArticlesSortByCreatedAt } from "../graphql/queries"

import { isoDateToMdyTime } from "../util/typeUtil"
import { sortByDate } from "../util/modelUtil"


const SearchResults = () => {
  
  const { isWhitelisted } = useContext(UserContext)
  let { term } = useParams()
  const [searchResults, setSearchResults] = useState([])

  const [nextToken, setNextToken] = useState(null)
  const [prevTokens, setPrevTokens] = useState([])
  const [pageNumber, setPageNumber] = useState(1)
  const [token, setToken] = useState(null)
  const pageLimit = 50


  const search = async (theToken) => {
    try {
      const res = await API.graphql(
        graphqlOperation(queryFccArticlesByListFccArticlesSortByCreatedAt, {
          sortCreatedAt: "T",
          sortDirection: "DESC",
          first: pageLimit,
          after: theToken,
          filter: {
            and: [
              { publishedAt: { gt: '0000-00-00T00:00:00Z' } },
              {
                or: [
                  { title: { contains: term.trim() } },
                  { content: { contains: term } },
                ],
              },
            ],
          },
        })
      )
      let items = res.data.queryFccArticlesByListFccArticlesSortByCreatedAt.items
      items = items.filter((record) => !record._deleted)
      items = sortByDate(items, 'publishedAt')

      setSearchResults(items)
      setToken(res.data.queryFccArticlesByListFccArticlesSortByCreatedAt.nextToken)
      
    } catch (error) {
      console.error("Error fetching search results:", error)
    }
  }

  const handleNext = async () => {
    setPrevTokens([...prevTokens, token])
    setPageNumber(pageNumber + 1)
  }

  const handlePrevious = async () => {
    setToken(prevTokens[prevTokens.length - 2])
    setPrevTokens(prevTokens.slice(0, -1))
    setPageNumber(pageNumber - 1)
  }

  useEffect(() => {
    let canceled = false // prevent state update if component unmounted

    if (term !== undefined) {
      search(token)
    }

    return () => {
      canceled = true
    }
  }, [term, pageNumber])


  return (
    <>
      { isWhitelisted ? <NavbarWhitelisted /> : <Navbar />}

      <div className="container-fluid banner text-center text-white">
        Search Results
      </div>

      <div className="page-container">
        <div className="row">
          <div className="col">
            <h5>Search Results for <em>"{term}"</em></h5>
          </div>
        </div>

        <br/><hr/>

        <div className="row text-end" style={{backgroundColor: "whitesmoke"}}>
          <div className="col-sm-10 pt-2">
            <nav>
              <ul className="pagination">
                <li className={`page-item ${prevTokens.length === 0 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={handlePrevious}>Previous</button>
                </li>
                <li className={`page-item ${!token ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={handleNext}>Next</button>
                </li>
              </ul>
            </nav>
          </div>
          <div className="col-sm-2 pt-3">
            <strong style={{color: '#4e4e4e'}}>Page {pageNumber}</strong>
          </div>
        </div>
        
        <br/>

        {searchResults && searchResults.length > 0 ?
          searchResults.map((articleItem, index) => (
            <div className="article" key={index}>
              <h4>{articleItem.title}</h4>
              {articleItem.content && <p className="summary" dangerouslySetInnerHTML={{ __html: articleItem.content }} />}
              <br/>
            </div>
          ))
        : 
          <div className="col-md-12">No results found.</div>
        }
        
        
        <div className="row text-end" style={{backgroundColor: "whitesmoke"}}>
          <div className="col-sm-10 pt-2">
            <nav>
              <ul className="pagination">
                <li className={`page-item ${prevTokens.length === 0 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={handlePrevious}>Previous</button>
                </li>
                <li className={`page-item ${!token ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={handleNext}>Next</button>
                </li>
              </ul>
            </nav>
          </div>
          <div className="col-sm-2 pt-3">
            <strong style={{color: '#4e4e4e'}}>Page {pageNumber}</strong>
          </div>
        </div>

      </div>
    </>
  );
};

export default SearchResults;
